import { render, staticRenderFns } from "./changeFiledName.vue?vue&type=template&id=31c66a92&"
import script from "./changeFiledName.vue?vue&type=script&lang=js&"
export * from "./changeFiledName.vue?vue&type=script&lang=js&"
import style0 from "./changeFiledName.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports